export default function translate(i18n, propriete) {
  if (propriete === 'dateFacturation') return i18n.t('facturation.date');
  if (propriete === 'assistantId') {
    return i18n.t('validationAcompte.assistant');
  }
  if (propriete === 'commercialId') {
    return i18n.t('validationAcompte.commercial');
  }
  return propriete;
}
